import React, { useEffect, useRef, useState } from "react";
import "./satisfiedcustomers.css";

const SatisfiedCustomers = () => {
  const statsData = [
    { value: 10000, suffix: "+", label: "Happy Customers", icon: "😊" },
    { value: 100, suffix: "+", label: "Banking Partners", icon: "🏦" },
    { value: 500, suffix: " Cr+", label: "Loans Disbursed", icon: "💰" },
    { value: 4.9, suffix: "★", label: "Customer Rating", icon: "⭐" },
  ];

  const StatsSection = () => {
    const sectionRef = useRef(null);
    const [startCount, setStartCount] = useState(false);

    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setStartCount(true);
            observer.disconnect();
          }
        },
        { threshold: 0.4 },
      );

      if (sectionRef.current) observer.observe(sectionRef.current);
      return () => observer.disconnect();
    }, []);
  };

  const StatCard = ({ stat, start }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
      if (!start) return;

      let startValue = 0;
      const duration = 2000;
      const increment = stat.value / (duration / 16);

      const counter = setInterval(() => {
        startValue += increment;
        if (startValue >= stat.value) {
          setCount(stat.value);
          clearInterval(counter);
        } else {
          setCount(startValue);
        }
      }, 16);

      return () => clearInterval(counter);
    }, [start, stat.value]);

  };

  const t = {
    testimonialTitle: "What Our Customers Say",
    testimonialSubtitle:
      "Hear From Our Satisfied Clients About Their Experience With Krishna Finconcept Services",
    testimonials: [
      {
        name: "Amit Sharma",
        photo: "/avatars/amit.png",
        rating: 5,
        text: "Krishna Finconcept Services made getting my home loan so easy! Excellent service and quick approval.",
      },
      {
        name: "Priya Patel",
        photo: "/avatars/priya.png",
        rating: 5,
        text: "Great platform with multiple options. Found the best interest rate for my personal loan.",
      },
      {
        name: "Rahul Verma",
        photo: "/avatars/rahul.png",
        rating: 4,
        text: "As a DSA partner, Krishna Finconcept Services has boosted my earnings with timely commissions and great support.",
      },
      {
        name: "Sneha Gupta",
        photo: "/avatars/sneha.png",
        rating: 5,
        text: "Quick and hassle-free health insurance. Saved a lot compared to direct purchase!",
      },
      {
        name: "Vikram Singh",
        photo: "/avatars/amit.png",
        rating: 5,
        text: "User-friendly EMI calculator and seamless business loan application process.",
      },
    ],
  };

  return (
    <div className="sc-page">
      {/* 1. HERO - REDESIGNED */}
      <section className="sc-hero redesigned">
        <div className=".skf-hero-content"></div>
        <div className="hero-content">
          <span className="hero-badge">Trusted by 10,000+ Customers</span>
          <h1>
            Thousands of Customers{" "}
            <span className="gradient-text">Trust Us</span>
          </h1>
          <p>
            Delivering reliable financial solutions with transparency, speed,
            and customer satisfaction.
          </p>
        </div>
        <div className="hero-stats-preview">
          <div className="hero-stat-item">
            <span className="hero-stat-value">10K+</span>
            <span className="hero-stat-label">Happy Customers</span>
          </div>
          <div className="hero-stat-divider"></div>
          <div className="hero-stat-item">
            <span className="hero-stat-value">4.9★</span>
            <span className="hero-stat-label">Rating</span>
          </div>
          <div className="hero-stat-divider"></div>
          <div className="hero-stat-item">
            <span className="hero-stat-value">500Cr+</span>
            <span className="hero-stat-label">Loans</span>
          </div>
        </div>
      </section>

      {/* 2. TRUST HIGHLIGHTS */}
      {/* 2. TRUST HIGHLIGHTS - REDESIGNED WITH HEADING */}
      <section className="sc-trust">
        <div className="trust-header">
          <span className="trust-badge">Why Choose Us</span>
          <h2 className="trust-title">
            Built on <span className="gradient-text">Trust & Innovation</span>
          </h2>
          <p className="trust-subtitle">
            Experience the difference with our customer-first approach and
            industry-leading features
          </p>
        </div>

        <div className="trust-grid">
          <div className="sc-trust-card" data-icon="🛡️">
            <div className="trust-card-inner">
              <div className="trust-icon-wrapper">
                <span className="sc-trust-icon">🛡️</span>
              </div>
              <h4>RBI-Compliant Process</h4>
              <p>
                Fully regulated and compliant with RBI guidelines for your peace
                of mind.
              </p>
              <div className="trust-card-footer">
                <span className="trust-feature">100% Compliant</span>
              </div>
            </div>
            <div className="trust-card-glow"></div>
          </div>

          <div className="sc-trust-card" data-icon="⚡">
            <div className="trust-card-inner">
              <div className="trust-icon-wrapper">
                <span className="sc-trust-icon">⚡</span>
              </div>
              <h4>100% Digital Journey</h4>
              <p>
                Apply, track, and approve loans completely online with zero
                paperwork.
              </p>
              <div className="trust-card-footer">
                <span className="trust-feature">Instant Approval</span>
              </div>
            </div>
            <div className="trust-card-glow"></div>
          </div>

          <div className="sc-trust-card" data-icon="🔒">
            <div className="trust-card-inner">
              <div className="trust-icon-wrapper">
                <span className="sc-trust-icon">🔒</span>
              </div>
              <h4>Secure & Encrypted Data</h4>
              <p>
                Your personal and financial data is always protected with
                bank-grade security.
              </p>
              <div className="trust-card-footer">
                <span className="trust-feature">256-bit Encryption</span>
              </div>
            </div>
            <div className="trust-card-glow"></div>
          </div>

          <div className="sc-trust-card" data-icon="👨‍💼">
            <div className="trust-card-inner">
              <div className="trust-icon-wrapper">
                <span className="sc-trust-icon">👨‍💼</span>
              </div>
              <h4>Expert Financial Advisors</h4>
              <p>
                Get guidance from certified loan specialists with 10+ years of
                experience.
              </p>
              <div className="trust-card-footer">
                <span className="trust-feature">Free Consultation</span>
              </div>
            </div>
            <div className="trust-card-glow"></div>
          </div>
        </div>
      </section>

      {/* CUSTOMER SUCCESS STORIES – TIMELINE STYLE */}
      <section className="sc-success-timeline">
        <div className="sc-success-header">
          <h2>Customer Success Stories</h2>
          <p>How our customers achieved their financial goals</p>
        </div>

        <div className="sc-timeline">
          <div className="sc-timeline-item">
            <div className="sc-timeline-number">01</div>
            <div className="sc-timeline-content">
              <h4>Home Loan Approved in 72 Hours</h4>
              <p>
                A salaried professional used our instant eligibility check and
                received loan approval within just 3 days.
              </p>
              <span className="sc-timeline-tag">Home Loan</span>
            </div>
          </div>

          <div className="sc-timeline-item">
            <div className="sc-timeline-number">02</div>
            <div className="sc-timeline-content">
              <h4>Business Loan for Rapid Expansion</h4>
              <p>
                A small business owner secured funding at competitive rates to
                expand operations across multiple cities.
              </p>
              <span className="sc-timeline-tag">Business Loan</span>
            </div>
          </div>

          <div className="sc-timeline-item">
            <div className="sc-timeline-number">03</div>
            <div className="sc-timeline-content">
              <h4>Instant Credit Card Approval</h4>
              <p>
                A first-time applicant received a premium credit card with zero
                documentation and exclusive rewards.
              </p>
              <span className="sc-timeline-tag">Credit Card</span>
            </div>
          </div>
        </div>
      </section>

      {/* TESTIMONIALS - MARQUEE FORMAT */}
      <section id="testimonials" className="section testimonials-section">
        <div className="section-header">
          <h2>{t.testimonialTitle}</h2>
          <p>{t.testimonialSubtitle}</p>
        </div>

        <div className="testimonials-marquee">
          <div className="testimonials-track">
            {/* Original set */}
            {t.testimonials.map((testimonial, index) => (
              <div key={`orig-${index}`} className="testimonial-card-marquee">
                <div className="testimonial-profile">
                  <img
                    src={testimonial.photo}
                    alt={testimonial.name}
                    className="profile-photo"
                  />
                  <div>
                    <h4>{testimonial.name}</h4>
                    <div className="star-rating">
                      {"★".repeat(testimonial.rating) +
                        "☆".repeat(5 - testimonial.rating)}
                    </div>
                  </div>
                </div>
                <p>{testimonial.text}</p>
              </div>
            ))}

            {/* Duplicated set for seamless infinite loop */}
            {t.testimonials.map((testimonial, index) => (
              <div key={`dup-${index}`} className="testimonial-card-marquee">
                <div className="testimonial-profile">
                  <img
                    src={testimonial.photo}
                    alt={testimonial.name}
                    className="profile-photo"
                  />
                  <div>
                    <h4>{testimonial.name}</h4>
                    <div className="star-rating">
                      {"★".repeat(testimonial.rating) +
                        "☆".repeat(5 - testimonial.rating)}
                    </div>
                  </div>
                </div>
                <p>{testimonial.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 3. CUSTOMER STATS */}
      <StatsSection />

      {/* 7. CTA */}
      <section className="sc-cta">
        <h2>Become Our Next Success Story</h2>
        <p>
          Join thousands of satisfied customers and achieve your financial goals
          today.
        </p>
        <button className="apply-btn">Apply Now</button>
      </section>
    </div>
  );
};

export default SatisfiedCustomers;
